import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition
} from '@angular/material';

@Injectable()
export class NotificationService {
  private snackBarRef: MatSnackBarRef<any>;
  private snackBarAutoHide = '5000';
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(private sb: MatSnackBar) {}

  loadSnackBar(_class: string): MatSnackBarConfig {
    const config = new MatSnackBarConfig();
    config.verticalPosition = this.verticalPosition;
    config.horizontalPosition = this.horizontalPosition;
    config.duration = parseInt(this.snackBarAutoHide, 0);
    config.panelClass = [_class];
    return config;
  }

  info(message) {
    const config = this.loadSnackBar('info-snackbar');
    this.sb.open(message, '', config);
  }

  error(message) {
    const config = this.loadSnackBar('error-snackbar');
    this.sb.open(message, '', config);
  }
}
